export default "__VITE_ASSET__DXg_8XDr__"